import React from 'react';
import {
  Box,
  Typography,
  Divider,
  TextField,
} from '@mui/material';
import FormActionBar from '../../../shared/components/FormActionBar';
import CustomerForm from './CustomerForm';
import CustomerItsmSection from './CustomerItsmSection';
import RoleTestResultDisplay from './RoleTestResultDisplay';
import { useCustomerForm } from '../hooks/useCustomerForm';
import { Customer } from '../../../types';

interface CustomerFormSectionProps {
  form: ReturnType<typeof useCustomerForm>;
  onCustomerUpdated?: (customer: Customer) => void;
}

const CustomerFormSection: React.FC<CustomerFormSectionProps> = ({ form, onCustomerUpdated }) => {
  return (
    <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
      <Box sx={{ maxWidth: 800 }}>
        <Typography variant="h6" gutterBottom>
          {form.isNewCustomer ? 'New Customer' : 'Customer Details'}
        </Typography>
        <Divider sx={{ mb: 3 }} />

        <CustomerForm
          formData={form.formData}
          selectedCustomer={form.selectedCustomer}
          isNewCustomer={form.isNewCustomer}
          fieldErrors={form.fieldErrors}
          testing={form.testing}
          onFieldChange={form.handleChange}
          onTestRole={form.handleTestRole}
        />

        {!form.isNewCustomer && form.selectedCustomer && (
          <>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Operations Event Forwarding (Advanced)
            </Typography>
            <TextField
              fullWidth
              label="Operations Event Bus Name"
              value={form.formData.operations_event_bus_name}
              onChange={(e) => form.handleChange('operations_event_bus_name', e.target.value)}
              placeholder="cloud2-customer-events"
              helperText="EventBridge bus in the operations account that forwards customer events to OpsPilot"
              InputLabelProps={{ shrink: true }}
            />
          </>
        )}

        {!form.isNewCustomer && form.selectedCustomer && form.testResult && (
          <Box sx={{ mt: 3 }}>
            <RoleTestResultDisplay testResult={form.testResult} />
          </Box>
        )}

        {!form.isNewCustomer && form.selectedCustomer && (
          <CustomerItsmSection
            customer={form.selectedCustomer}
            onSaved={(updated) => onCustomerUpdated?.(updated)}
          />
        )}

        <FormActionBar
          onSave={form.handleSave}
          saving={form.saving}
          saveDisabled={form.saving || !form.hasChanges()}
          saveLabel={form.isNewCustomer ? 'Create Customer' : 'Save Changes'}
          savingLabel={form.isNewCustomer ? 'Creating...' : 'Saving...'}
          onDelete={!form.isNewCustomer && form.selectedCustomer ? form.handleDeleteClick : undefined}
          deleteLabel="Delete Customer"
        />
      </Box>
    </Box>
  );
};

export default CustomerFormSection;
